module.exports = __webpack_public_path__ + "img/move.d3060536.svg";